module.exports = __webpack_public_path__ + "5766b6f11d3fc48b646d95324e2c2a3d.svg";